module.exports = __webpack_public_path__ + "static/img/get-me-online-palmybid.7d8ab20.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/get-me-online-palmybid.jpg
// module id = gJEW
// module chunks = 1